export default __webpack_public_path__ + "static/media/de.ee604894.svg";